<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <label>Estabelecimento</label>
        <v-select
          label="sie_estabelecimento"
          :options="estabelecimentos"
          v-model="estabelecimentoEntity"
          @input="onLoadDayData"
          :disabled="Object.keys(this.estabelecimento).length > 0"
        >
          <template slot="no-options">Pesquise estabelecimentos pela razão social</template>
        </v-select>
      </div>
      <div class="col-md-3">
        <label>Data</label>
        <datepicker-component
          v-model="selectedDate"
          input-class="form-control"
          @change="onSelectDay"
        ></datepicker-component>
      </div>
      <div class="col-md-2">
        <label>&nbsp;</label>
        <button
          class="btn btn-primary"
          :disabled="disableAddRegisterButton"
          @click="onAddItemClick"
        >Adicionar registro</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="ant-mortem-aves-report"
          modal-title="Gerar relatório mensal"
          button-text="Gerar relatório mensal"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="monthly" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.split('/').reverse().join('-')"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="ant-mortem-aves-report"
          modal-title="Gerar relatório do dia"
          button-text="Gerar relatório do dia"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="diary" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.split('/').reverse().join('-')"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
    </div>
    <div class="row mt-2" v-if="boletos.length">
      <div class="col-md-12">
        <h3>Boletos do mês</h3>
      </div>
      <div class="col-md-2" v-for="(boleto, index) in boletos" :key="index">
        <p class="text text-center">
          <i class="fa fa-file-pdf-o fa-4x"></i>
          <label class="text text-center">{{ boleto.description }}</label>
          <label class="text text-center">
            Status:
            <b
              :class="{text: true, 'text-success': boleto.pago, 'text-danger': !boleto.pago}"
            >{{ boleto.pago ? 'Pago' : 'Não pago' }}</b>
          </label>
          <a :href="boleto.link" class="text text-primary text-center" target="_blank">
            <i class="fa fa-download"></i> Baixar
          </a>
        </p>
      </div>
    </div>
    <div
      class="no-data-found mt-1"
      v-if="!selectedDate || !this.estabelecimentoEntity || !this.estabelecimentoEntity.cod_estabelecimento"
    >
      <i class="fa fa-exclamation-circle"></i>
      <p>Selecione o dia e o estabelecimento</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="isLoading">
      <i class="fa fa-spinner fa-pulse fa-fw"></i>
      <p>Carregando...</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="items.length === 0">
      <i class="fa fa-exclamation-circle"></i>
      <p>Nenhum registro encontrado.</p>
    </div>
    <div class="mt-2" v-else>
      <div class="sida-accordion">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{item, active: index === activeItem}"
          class="accordion-item"
          :data-index="index"
          :id="'accordion-' + index"
        >
          <h1
            class="accordion-title"
            @click="onChangeAccordion(index)"
          >GTA: {{ item.numero_gta }} | Série: {{item.serie_gta}} | Estado: {{item.estado_gta ? estados.find(estado => estado.id == item.estado_gta).value : ''}} | Data: {{ formatDate(item.data) }}
            <button
              class="btn btn-delete"
              @click="onDeleteClick($event, index)"
              :disabled="item.boleto_gerado"
            >
              <i class="fa fa-trash"></i>
            </button>
          </h1>
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>Estado da GTA</label>
                    <select-component v-model="item.estado_gta" @change="onChangeGtaSerie" name="estadogta" class="spacer">
                      <option
                        class="form-control"
                        v-for="item of estados"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.value }}</option>
                    </select-component>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>N° GTA</label>
                    <input
                      type="text"
                      class="form-control"
                      maxlength="6"
                      v-model="item.numero_gta"
                      @change="onChangeGtaSerie"
                      v-numeric
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>Série da GTA</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.serie_gta"
                      maxlength="2"
                      v-mask="['AA']"
                      @change="onChangeGtaSerie"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>CPF/CNPJ do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      v-model="item.cpf_cnpj_produtor"
                      :disabled="item.is_produtor_sidagro === true"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>Nome do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.nome_produtor"
                      :disabled="item.is_produtor_sidagro === true"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required" :id="'lb-municipio' + index">
                    <label style="margin-bottom: 5px;">Município</label>
                    <select-municipio-component
                      name="municipio"
                      v-model="item.municipio"
                      :disabled="item.is_produtor_sidagro === true"
                    ></select-municipio-component>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>UF</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.municipio.uf"
                      :disabled="item.is_produtor_sidagro === true"
                    />
                  </div>
                </div>
              </div>
              <fieldset class="sida-fieldset m-0 my-1">
                <legend>ANTE MORTEM</legend>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label>Qtd. aves recebidas</label>
                      <input
                        v-numeric
                        type="tel"
                        class="form-control"
                        v-model="item.qtd_aves_recebidas"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Qtd. aves mortas</label>
                      <input
                        v-numeric
                        type="tel"
                        class="form-control"
                        v-model="item.qtd_aves_mortas"
                      />
                    </div>
                    <template v-if="parseInt(item.qtd_aves_mortas) > parseInt(item.qtd_aves_recebidas)">
                      <span class="text text-danger">A quantidade de aves mortas deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_aves_recebidas) }} (quantidade de aves recebidas)</span>
                      <!-- VALIDATION PURPOSE: -->
                      <div class="form-group required">
                        <input
                          type="hidden"
                          class="form-control"
                        />
                      </div>
                    </template>
                  </div>
                </div>
              </fieldset>
              <fieldset class="sida-fieldset m-0 my-1">
                <legend>Destino das aves abatidas</legend>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Qtd. liberados</label>
                      <input v-numeric type="tel" class="form-control" v-model="item.qtd_liberado" />
                    </div>
                    <template v-if="item.qtd_liberado > item.qtd_aves_recebidas">
                      <span class="text text-danger">A quantidade de aves liberadas deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_aves_recebidas) }} (quantidade de aves recebidas)</span>
                      <!-- VALIDATION PURPOSE: -->
                      <div class="form-group required">
                        <input
                          type="hidden"
                          class="form-control"
                        />
                      </div>
                    </template>
                  </div>
                </div>
                <label class="text text-left text-bold">Condenações</label>
                <ant-mortem-aves-condenacoes v-model="item.condenacoes"></ant-mortem-aves-condenacoes>
                <div class="row">
                  <div class="col-md-4">&nbsp;</div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Totalmente Condenado (total)</label>
                      <input
                        v-numeric
                        type="tel"
                        class="form-control"
                        :value="countCondenacoesTotal(item)"
                        readonly
                      />
                    </div>
                    <template v-if="countCondenacoesTotal(item) > parseInt(item.qtd_aves_recebidas)">
                      <span class="text text-danger">A quantidade de aves Totalmente Condenadas deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_aves_recebidas) }} (quantidade de aves recebidas)</span>
                      <!-- VALIDATION PURPOSE: -->
                      <div class="form-group required">
                        <input
                          type="hidden"
                          class="form-control"
                        />
                      </div>
                    </template>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Parcialmente Condenado (total)</label>
                      <input
                        v-numeric
                        type="tel"
                        class="form-control"
                        :value="countCondenacoesParciais(item)"
                        readonly
                      />
                    </div>
                    <template v-if="countCondenacoesParciais(item) > parseInt(item.qtd_aves_recebidas)">
                      <span class="text text-danger">A quantidade de aves Parcialmente Condenado para Consumo humano deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_aves_recebidas) }} (quantidade de aves recebidas)</span>
                      <!-- VALIDATION PURPOSE: -->
                      <div class="form-group required">
                        <input
                          type="hidden"
                          class="form-control"
                        />
                      </div>
                    </template>
                  </div>
                </div>

                <label class="text text-left text-bold">Sequestrados</label>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Liberada totalmente para Consumo humano</label>
                      <input
                        v-numeric
                        type="tel"
                        class="form-control"
                        v-model="item.totalmente_liberado"
                      />
                    </div>
                    <template v-if="parseInt(item.totalmente_liberado) > parseInt(item.qtd_aves_recebidas)">
                      <span class="text text-danger">A quantidade de aves Liberada totalmente para Consumo humano deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_aves_recebidas) }} (quantidade de aves recebidas)</span>
                      <!-- VALIDATION PURPOSE: -->
                      <div class="form-group required">
                        <input
                          type="hidden"
                          class="form-control"
                        />
                      </div>
                    </template>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-sm-2">
        <input
          type="button"
          value="Pesquisar"
          name="Pesquisar"
          onclick="cadastro.pesquisar();"
          class="ui-button"
        />
      </div>
      <div class="col-sm-10">
        <div class="d-flex flex-row-reverse">
          <div class="d-flex justify-content-end">
            <input
              type="submit"
              value="Salvar"
              name="Salvar"
              class="btn"
              :disabled="disableSaveButton"
              @click="onSaveClick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    estabelecimento: {
      required: false,
    },
    estabelecimentos: {
      required: true,
    },
  },
  data: () => ({
    selectedDate: null,
    isLoading: false,
    estabelecimentoEntity: null,
    requestSource: null,
    searchTimeoutId: null,
    estados: [],
    items: [],
    boletos: [],
    deleted: [],
    // Accordion
    activeItem: null,
  }),
  watch: {
    selectedDate: function (val) {
      const selectedDate = moment(val, "DD/MM/YYYY");
      const endMonth = moment(selectedDate).endOf("month");
      const validPeriod = moment(endMonth).add(10, "days");
      const now = moment();
      if (
        !now.isSameOrBefore(validPeriod, "day") ||
        !now.isSameOrAfter(selectedDate, "day")
      ) {
        this.$toast.info("Você não pode fazer alterações na data selecionada.");
      }
    },
  },
  computed: {
    disableAddRegisterButton() {
      let dateValid = false;
      if (this.selectedDate) {
        const selectedDate = moment(this.selectedDate, "DD/MM/YYYY");
        const endMonth = moment(selectedDate).endOf("month");
        const validPeriod = moment(endMonth).add(10, "days");
        const now = moment();
        if (
          now.isSameOrBefore(validPeriod, "day") &&
          now.isSameOrAfter(selectedDate, "day")
        ) {
          dateValid = true;
        }
      }

      return (
        !dateValid ||
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento
      );
    },
    disableSaveButton() {
      return (
        this.selectedDate === null ||
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !this.items.length
      );
    },
  },
  methods: {
    formatDate(date){
      let _date = new Date(date);
      _date.setDate(_date.getDate() + 1);
      return _date.toLocaleDateString();
    },
    onDeleteClick(ev, index) {
      ev.preventDefault();
      ev.stopPropagation();

      const item = this.items[index];

      this.$dialog
        .confirm("Deseja realmente apagar este item?")
        .then((dialog) => {
          this.$dialog.alert('Os dados serão apagados apenas após clicar no botão salvar.').then((dialog) => {
            if (item.cod_ant_mortem_aves) {
              this.deleted.push(item.cod_ant_mortem_aves);
            }
            this.items.splice(index, 1);
          });
        })
        .catch((e) => {
          console.log("Clicked on cancel", e);
        });
    },
    countCondenacoesTotal(item) {
      const qtdCondTotal = item.condenacoes.reduce((acc, curr) => parseInt(curr.cond_total || 0) + acc, 0);
      return qtdCondTotal || 0;
    },
    countCondenacoesParciais(item) {
      const qtdCondParcial = item.condenacoes.reduce((acc, curr) => parseInt(curr.cond_parcial || 0) + acc, 0);
      return qtdCondParcial || 0;
    },
    onAddItemClick() {
      const emptyItem = this.getEmptyItem();

      this.items.push(emptyItem);

      const index = this.items.length - 1;

      this.onChangeAccordion(this.items.length - 1);
    },
    onSelectDay(val) {
      this.selectedDate = val;
      this.onLoadDayData();
    },
    onLoadDayData() {
      if (
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !this.selectedDate
      ) {
        return;
      }

      this.isLoading = true;
      this.boletos = [];

      window.api
        .fetch(`/acompanhamentos/ant-mortem-aves/load-day-data`, {
          params: {
            date: this.selectedDate,
            cod_pj: this.estabelecimentoEntity.cod_estabelecimento,
          },
        })
        .then((response) => {
          this.items = response.data.registers.map((item) => {
            item.municipio = {
              label: item.municipio,
              value: item.cod_municipio,
              uf: item.uf,
            };

            item.estado_gta = item.cod_estado_gta;
            return item;
          });

          if (response.data.boletos && response.data.boletos.length) {
            this.boletos = response.data.boletos;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    onLoadFaixasEtarias() {
      const item = this.items[this.activeItem];
      if (!item.cod_especie) {
        return;
      }

      axios
        .get(
          `/produtor/pre-cadastro/get-faixas-etarias-exploracao?cod_especie=${item.cod_especie}`
        )
        .then((response) => response.data)
        .then((response) => {
          const { data } = response;
          const totais = data.map((total) => {
            let qtdTotal = 0;
            if (item.quantidades) {
              const qtdSidagro = item.quantidades.find(
                (el) => el.id_estratificacao === total.cod_estratificacao
              );
              if (qtdSidagro) {
                qtdTotal = qtdSidagro.total;
              }
            }

            total.qtd = qtdTotal;
            return total;
          });
          this.items[this.activeItem].totais = totais;

          this.$forceUpdate();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeMatancaEmergencia(ev, index) {
      const item = this.items[index];
      item.matancaEmergencia[ev.index] = item.matancaEmergencia[ev.index] || {};
      item.matancaEmergencia[ev.index][ev.name] = ev.value;
    },
    onChangeRetidosObservacao(ev, index) {
      const item = this.items[index];
      item.retidosObservacao[ev.index] = item.retidosObservacao[ev.index] || {};
      item.retidosObservacao[ev.index][ev.name] = ev.value;
    },
    onChangeAnimaisRefugados(ev, index) {
      const item = this.items[index];
      item.animaisRefugados[ev.index] = item.animaisRefugados[ev.index] || {};
      item.animaisRefugados[ev.index][ev.name] = ev.value;
    },
    onChangePosMortem(ev, index) {
      const item = this.items[index];
      item.posMortem[ev.index] = item.posMortem[ev.index] || {};
      item.posMortem[ev.index][ev.name] = ev.value;
    },
    onChangeAnimaisMortosChegada(ev, index) {
      const item = this.items[index];
      item.animaisMortosChegada[ev.index] =
        item.animaisMortosChegada[ev.index] || {};
      item.animaisMortosChegada[ev.index][ev.name] = ev.value;
    },
    onChangeAccordion(index) {
      if (this.activeItem === index) {
        this.activeItem = null;
        return;
      }

      this.activeItem = index;

      const beforeIndex = index == 0 ? index : index - 1;
      const accordionItem = document.getElementById("accordion-" + beforeIndex);
      const topPos = $(accordionItem).offset().top;
      $("html, body").animate(
        {
          scrollTop: topPos,
        },
        1000
      );
    },
    onSaveClick() {
      let hasError = false;
      let accordion = this.$el.querySelector('.sida-accordion');
      let gtivs = accordion.querySelectorAll('.accordion-item');
      gtivs.forEach((gtiv) => {
        let gtivError = false;
        // console.log(gtiv);
        gtiv.querySelectorAll(".form-group.required").forEach((node) => {
          const formControl = node.querySelector(".form-control");
          // console.log(formControl);
          if (!formControl.value) {
            node.classList.add("error");
            hasError = true;
            gtivError = true;
          } else {
            node.classList.remove("error");
          }
        });
        if(gtivError) {
          gtiv.querySelector('.accordion-title').classList.add("error");
        } else {
          gtiv.querySelector('.accordion-title').classList.remove("error");
        }
      });
      

      if (hasError) {
        this.$toast.error("Preencha os campos obrigatórios.");
        return;
      }

      const formData = new FormData();
      formData.set("data", JSON.stringify(this.items.map(item => {
        item.totalmente_condenado = this.countCondenacoesTotal(item);
        item.parcialmente_condenado = this.countCondenacoesParciais(item);
        return item;
      })));
      formData.set("deleted", JSON.stringify(this.deleted));


      window.api
        .fetch("/acompanhamentos/ant-mortem-aves/salvar", {
          method: "post",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response?.data?.duplicated) {
            this.$dialog
              .confirm(response.data.message, {
                okText: "Sim",
                cancelText: "Não",
              })
              .then(() => {
                formData.set("force_save", true);
                this.proceedSave(formData);
              })
              .catch(() => {
                this.$toast.info("Ação cancelada pelo usuário.");
              });
          } else {
            this.$toast.success("Dados salvos com sucesso.");
            setTimeout(() => location.reload(), 1000);
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao salvar os dados.");
        });
    },
    proceedSave(formData) {
      window.api
        .fetch("/acompanhamentos/ant-mortem-aves/salvar", {
          method: "post",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.$toast.success("Dados salvos com sucesso.");
          setTimeout(() => location.reload(), 1000);
        })
        .catch(() => {
          this.$toast.error("Erro ao salvar os dados.");
        });
    },
    onChangeGtaSerie() {
      const item = this.items[this.activeItem];
      if (!item.numero_gta || !item.serie_gta || !item.estado_gta) {
        return;
      }

      const formData = new FormData();
      formData.set("numero", item.numero_gta);
      formData.set("serie", item.serie_gta);
      formData.set("estado", item.estado_gta);
      formData.set("grupos_especie", "6");

      window.api
        .fetch(
          "/acompanhamentos/ant-mortem-aves/load-sidagro-data-by-gta", {
            method: "post",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          const data = response.data;

          if (![1, 15].includes(data.id_finalidade)) {
            this.$toast.error(
              "GTA Inválida. A GTA deve ser de finalidade ABATE ou ABATE SANITÁRIO."
            );
            this.items[this.activeItem].numero_gta = "";
            this.items[this.activeItem].serie_gta = "";
            this.items[this.activeItem].estado_gta = "";
            return;
          }

          const qtd_aves_recebidas = data.quantidades.reduce((acc, item) => {
            return acc + Number(item.total);
          }, 0);

          this.$set(this.items, this.activeItem, {
            ...item,
            cod_estabelecimento: this.estabelecimentoEntity.cod_estabelecimento,
            cpf_cnpj_produtor: data.nr_cpf_cnpj,
            data: this.selectedDate.split("/").reverse().join("-"),
            is_produtor_sidagro: true,
            municipio: {
              label: data.municipioorigem,
              value: data.codmunicipioibgeorigem,
              uf: data.uforigem,
            },
            nome_produtor: data.nm_pessoa,
            numero_gta: data.numerogta,
            serie_gta: data.seriegta,
            qtd_aves_recebidas,
          });

          this.onLoadFaixasEtarias(this.activeItem);
        })
        .catch((error) => {
          this.items[this.activeItem].numero_gta = "";
          this.items[this.activeItem].serie_gta = "";
        });
    },
    getEmptyItem() {
      return {
        cod_pos_mortem_aves: null,
        cod_estabelecimento: this.estabelecimentoEntity.cod_estabelecimento,
        cpf_cnpj_produtor: null,
        data: this.selectedDate.split("/").reverse().join("-"),
        is_produtor_sidagro: null,
        municipio: {
          label: null,
          value: null,
          uf: null,
        },
        nome_produtor: null,
        estado_gta: null,
        numero_gta: null,
        serie_gta: null,
        qtd_liberados_matanca_normal: null,
        observations: null,
        sequestrado: [],
        condenacoes: [],
        qtd_aves_recebidas: null,
        qtd_aves_mortas: null,
        qtd_liberado: null,
        qtd_sem_liberacao: null,
      };
    },
  },
  mounted() {
    if (Object.keys(this.estabelecimento).length) {
      this.estabelecimentoEntity = {
        estabelecimento: this.estabelecimento.nome,
        sie_estabelecimento: this.estabelecimento.num_sie + ' - ' + this.estabelecimento.nome,
        cod_estabelecimento: this.estabelecimento.cod_estabelecimento,
      };
    }
    this.estabelecimentos.map(function (x){
      return x.sie_estabelecimento = x.num_sie + ' - ' + x.estabelecimento;
    });
    window.api
        .fetch(
          "/util/get-estados-list",
          {
            method: "get",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          this.estados = response;
          // console.log(this.estados);
        })
        .catch((error) => {
          this.$toast.error(
              "Erro ao buscar lista de estados."
            );
        });
  },
};
</script>
<style lang="scss" scoped>
.sida-accordion .item .content {
  background: #f3f3f3;
}

.container {
  .no-data-found {
    padding: 100px 16px;
  }
}

.spacer {
  margin-top: 5px;
}
</style>
